<template>
  <field-block
    class="mt-8"
    title="Most helpful links"
    description="You do not need to review all documentation. Watch the video above and use the links below."
  >
    <div class="links-list-wrap">
      <v-row class="links-list pb-2 pt-2">
        <v-col
          cols="12"
          class="pl-4 pr-4 pt-3 pb-2"
          v-for="(link, idx) in helpDocumentations"
          :key="idx"
        >
          <div>
            <a
              :href="fullHelpRoute(link.link)"
              target="_blank"
              class="help-link"
            >
              <span class="help-link__icon">
                <icon-base :icon="link.icon" :font-icon="link.fontIcon" />
              </span>
              <span class="help-link__text">
                {{ link.text }}
              </span>
            </a>
          </div>
        </v-col>
      </v-row>
    </div>
  </field-block>
</template>

<script>
const helpDocumentations = [
  {
    text: 'Making snippets',
    icon: 'sidebar/snippets',
    link: 'snippets',
  },
  {
    text: 'Creating/managing groups',
    icon: 'sidebar/groups',
    link: 'groups-creation-filtering-and-setup',
  },
  {
    text: 'Resetting a user password',
    icon: 'password',
    fontIcon: true,
    link: 'changing-your-password',
  },
];

export default {
  name: 'RecrutingHomeHelp',
  data() {
    return {
      helpDocumentations,
    };
  },
  methods: {
    fullHelpRoute(route) {
      const base = 'https://conveyour.com/help';
      if (route) {
        return `${base}/${route}`;
      }
      return base;
    },
  },
};
</script>

<style scoped lang="less">
.links-list-wrap {
  padding: 16px;
  background-color: #fff;
  box-shadow: @base-shadow;
  border-radius: @base-radius;
}
.links-list {
  .help-link {
    display: flex;
    align-items: center;
    margin-left: 0;
    text-decoration: none;

    &__text {
      text-decoration: underline;
    }

    &__icon {
      height: 22px;
      width: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
    }

    img {
      display: block;
      height: auto;
      width: auto;
    }

    &:hover {
      .help-link__text {
        text-decoration: none;
      }
    }
  }
}
</style>
